import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';

const RadioInput = ({
  field: { name, value, onChange, onBlur },
  id,
  label,
  color,
  ...props
}) => (
  <RadioWrap>
    <StyledRadio
      color={color}
      name={name}
      id={id}
      type="radio"
      value={id}
      checked={id === value}
      onChange={onChange}
      onBlur={onBlur}
      {...props}
    />
    <label htmlFor={id}>{label}</label>
  </RadioWrap>
);

const RadioWrap = styled.div`
  vertical-align: middle;
  display: inline-block;
  text-align: left;

  ${props => props.styles && css`
    ${props.styles}
  `}

  ${screen.below(bp.mobileRealSm, `
    text-align: center;
  `)};
`;

const StyledRadio = styled.input`
  &[type="radio"]:checked,
  &[type="radio"]:not(:checked) {
    position: absolute;
    left: -9999px;
  }

  &[type="radio"] + label {
    position: relative;
    cursor: pointer;
    display: block;
    color: ${props => props.isDark ? '#000' : '#fff'};
    padding-left: 40px;
    transition: color .3s ease;
    line-height: 1.2;
    z-index: 1;

    ${screen.below(bp.mobileRealSm, `
      padding-left: 20px;
    `)};
  }

  &[type="radio"] + label::before,
  &[type="radio"] + label::after {
    content: "";
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }

  &[type="radio"] + label::before {
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background-color: rgba(${props => props.isDark ? '0,0,0' : '255,255,255'},.2);
  }

  &[type="radio"] + label::after {
    left: 4px;
    top: calc(50% - 4px);
    width: 8px;
    height: 8px;
    transform: translateY(-50%);
    background-color: ${props => props.theme.blue};
    transition: all .3s ease;
    z-index: 1;
  }

  &[type="radio"]:checked + label {
    color: ${props => props.isDark ? props.theme.black : '#fff'};
  }

  &[type="radio"]:not(:checked) + label::after {
    opacity: 0;
    transform: scale(0);
  }

  &[type="radio"]:checked + label::after {
    opacity: 1;
    transform: scale(1);
  }
`;

RadioInput.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  id: PropTypes.string,
  label: PropTypes.string,
};

export default RadioInput;
